import { Component, OnInit, OnDestroy, ViewChild, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ServerService } from '../../service/server/server.service';
import { UserSearchComponent } from '../../user/user-search/user-search.component';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModulesComponent } from '../../service/modules/modules.component';
import { UserVideoComponent } from '../../user/user-video/user-video.component';
import { MessageService } from '../../service/message/message.service';
@Component({
  selector: 'app-finanace-cardex-detaile',
  templateUrl: './finanace-cardex-detaile.component.html',
  styleUrls: ['./finanace-cardex-detaile.component.scss']
})
export class FinanaceCardexDetaileComponent implements OnInit, OnDestroy {
  public user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public server: string = this.serverService.get_server();
  public server_main: string = this.serverService.get_server_main();
  public site: string = this.serverService.get_site();
  public no_record: string = this.serverService.no_record();
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public loading: boolean = false;
  public subscription: Subscription | any;
  public form1: FormGroup | any;
  public user_id!: number;
  public creator!: number;
  public id!: number;
  public video!: string;
  public code!: number;
  constructor(
    public serverService: ServerService,
    public router: Router,
    public matSnackBar: MatSnackBar,
    public messageService: MessageService,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<FinanaceCardexDetaileComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any) {
    if (dialog_data) {
      this.creator = dialog_data.creator;
      this.id = dialog_data.id;
      this.code = dialog_data.id;
    }
    this.create_form();
    if (dialog_data.res_search_finance_cardex) {
      this.form1.patchValue({
        'user_title': dialog_data.res_search_finance_cardex.user_title,
        'user': dialog_data.res_search_finance_cardex.user,
        'date1': dialog_data.res_search_finance_cardex.date1,
        'date2': dialog_data.res_search_finance_cardex.date2,
      })
    }
  }//end consructor
  ngOnInit() {
    if (this.user_info) {
      this.user_id = this.user_info.user_id;
    }
    this.check_access();
  }
  check_access(): any {
    if (this.messageService.check_internet() == false) {
      this.message(true, this.messageService.internet(), 1, this.messageService.close());
      return false;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, type: 'user', user_id: this.user_id, id: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.message(true, this.messageService.access2(), 1, this.messageService.close());
          }
          else {
            this.video = res['result'][0].video;
            this.loading = false;
          }
        }//end if
        else {
          this.message(true, this.messageService.access2(), 1, this.messageService.close());
        }
      }
    )
  }
  open_video() {
    this.dialog.open(UserVideoComponent, {
      width: '45rem',
      height: 'auto',
      data: { id: this.code }
    })
  }
  create_form() {
    this.form1 = new FormGroup({
      'user_title': new FormControl(null),
      'user': new FormControl(null, [Validators.pattern("[0-9]{1,}")]),
      'date1': new FormControl(null),
      'date2': new FormControl(null),
    });
  }
  open_user() {
    const dialogRef = this.dialog.open(UserSearchComponent, {
      width: '40rem',
      height: 'auto',
      data: { code: 193 }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {
          this.form1.patchValue({
            'user_title': res.title,
            'user': res.id
          })
        }
      }
    )
  }
  search() {
    var date1;
    var date2;
    if (this.form1.value.date1) { date1 = `${this.form1.value.date1.toISOString()}`; }
    if (this.form1.value.date2) { date2 = `${this.form1.value.date2.toISOString()}`; }
    var obj = {
      'user': this.form1.value.user
      , date1: date1, date2: date2, search: true
    };
    this.router.navigate(['/home/finance-cardex/226'], { queryParams: obj });
    this.close(false);
  }
  close(close: boolean) {
    var obj = {
      'user': this.form1.value.user,
      'user_title': this.form1.value.user_title,
      'close': close,
      'date1': this.form1.value.date1,
      'date2': this.form1.value.date2
    }
    this.matDialogRef.close(obj);
  }
  reset_customer() {
    this.form1.patchValue({
      user_title: null,
      user: null
    })
  }
  load_services(id: number) {
    const dialogRef = this.dialog.open(ModulesComponent, {
      width: '40rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, creator: this.creator }
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if (res) {

        }
      }
    )
  }
  reset_input(id: number) {

  }
  //**************************************************
  message(validation: boolean, message: string, type: number, action: string) {
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(message, action, { duration: 4000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }//end 
  //*******************************************************************************
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }//end if
  }//end OnDestroy
}